import React from 'react';

/** Green→red scale for a [0,1] unit similarity in the meaningful ~[0.925, 1] range (== 0.85..1 cosine). */
export function simColor(s) {
  const t = Math.max(0, Math.min(1, ((Number(s) || 0) - 0.88) / 0.12));
  return `hsl(${t * 120}, 70%, 42%)`;
}

/** Cosine similarity (~[-1, 1]) → the [0, 1] unit scale simColor is calibrated for. */
export function cosineToUnit(c) {
  return ((Number(c) || 0) + 1) / 2;
}

/**
 * Colored badge for a similarity score. `value` is a [0,1] unit similarity by default; pass
 * `cosine` when `value` is a raw cosine similarity so the color is computed on the right scale
 * (the number shown is always `value` itself). `digits` controls the displayed precision.
 */
const SimilarityBadge = React.memo(function SimilarityBadge({
  value, cosine = false, digits = 3, title = 'similarity [0,1]', className = '', style = {},
}) {
  const num = cosine ? cosineToUnit(value) : Number(value) || 0;
  
  return (
    <span
      className={`badge text-white ${className} align-middle`}
      style={{ background: simColor(num), ...style }}
      title={title}
    >
      {num.toFixed(digits)}
    </span>
  );
});

export default SimilarityBadge;
